export default "__VITE_ASSET__DIjXQOEy__"